import { render } from "./register-window.component.vue?vue&type=template&id=52b61bda&ts=true"
import script from "./register-window.component.vue?vue&type=script&lang=ts"
export * from "./register-window.component.vue?vue&type=script&lang=ts"

import "./register-window.component.vue?vue&type=style&index=0&id=52b61bda&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__